"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MicroEmitter {
    constructor() {
        this.listeners = {};
    }
    registerListener(eventType, listener, once) {
        this.listeners[eventType] = this.listeners[eventType] || [];
        this.listeners[eventType].push({ listener, once });
        return this;
    }
    addListener(eventType, listener) {
        return this.registerListener(eventType, listener, false);
    }
    on(eventType, listener) {
        return this.addListener(eventType, listener);
    }
    addOnceListener(eventType, listener) {
        return this.registerListener(eventType, listener, true);
    }
    once(eventType, listener) {
        return this.addOnceListener(eventType, listener);
    }
    removeListener(eventType, listener) {
        if (!this.listeners[eventType]) {
            return this;
        }
        if (!this.listeners[eventType].length) {
            return this;
        }
        if (!listener) {
            delete this.listeners[eventType];
            return this;
        }
        this.listeners[eventType] = this.listeners[eventType].filter((_listener) => !(_listener.listener === listener));
        return this;
    }
    off(eventType, listener) {
        return this.removeListener(eventType, listener);
    }
    emit(eventType, payload) {
        if (!this.listeners[eventType]) {
            return this;
        }
        this.listeners[eventType].forEach((listener) => {
            listener.listener.apply(this, [payload]);
            if (listener.once) {
                this.removeListener(eventType, listener.listener);
            }
        });
        return this;
    }
    trigger(eventType, payload) {
        return this.emit(eventType, payload);
    }
}
exports.default = MicroEmitter;
